<div class="page">
    <div class="header unselectable">
        <div class="subheader">
            <span class="title">
                Chat History
            </span>
            <a [routerLink]="['/', 'home', 'voice']">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6">
                    <path d="M11.47 3.841a.75.75 0 0 1 1.06 0l8.69 8.69a.75.75 0 1 0 1.06-1.061l-8.689-8.69a2.25 2.25 0 0 0-3.182 0l-8.69 8.69a.75.75 0 1 0 1.061 1.06l8.69-8.689Z" />
                    <path d="m12 5.432 8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0-.75.75V21a.75.75 0 0 1-.75.75H5.625a1.875 1.875 0 0 1-1.875-1.875v-6.198a2.29 2.29 0 0 0 .091-.086L12 5.432Z" />
                </svg>
            </a>
        </div>
    </div>
    <div class="content">
        <div class="search-box">
            <input [formControl]="searchQueryControl" id="inpu-search" />
            <img src="assets/images/noun-search-4648873 1.svg" alt="search" class="action-search">
        </div>
        <div class="history">
            @if(!isLoading()) {
                @for (coversation of coversations(); track coversation.conversationId) {
                    <div class="history-item">
                        <span class="message">
                            <a [routerLink]="['/', 'home', 'voice', coversation.conversationId]">
                                {{coversation.title}}
                            </a>
                        </span>
                        <span class="actions">
                            <!-- <a [routerLink]="['/', 'home', 'voice', coversation.conversationId]">
                                <img src="assets/images/Play message button.svg" alt="play" class="action-image">
                            </a> -->
                            <!-- <img src="assets/images/Share.svg" alt="share" class="action-image"> -->
                            <img src="assets/images/noun-trash-3465736 1.svg" alt="delete"
                                (click)="delete(coversation.conversationId)" class="action-image">
                        </span>
                    </div>
                } @empty {
                    <div class="history-item">
                        <span class="message">
                            No chat found.
                        </span>
                    </div>
                }
            }
        </div>
    </div>
</div>

@if(IsDeleteDialogShown()) {
    <div class="fixed inset-0 flex items-center justify-center z-50 backdrop-blur confirm-dialog ">
        <div class="relative px-4 min-h-screen md:flex md:items-center md:justify-center">
            <div class=" opacity-25 w-full h-full absolute z-10 inset-0"></div>
            <div class="bg-white rounded-lg md:max-w-md md:mx-auto p-4 fixed inset-x-0 bottom-0 z-50 mb-4 mx-4 md:relative shadow-lg">
                <div class="md:flex items-center">
                    <!-- <div class="rounded-full border border-gray-300 flex items-center justify-center w-16 h-16 flex-shrink-0 mx-auto">
                        <i class="bx bx-error text-3xl">
                        &#9888;
                        </i>
                        </div> -->
                        <div class="mt-4 md:mt-0 md:ml-6 text-center md:text-left">
                        <p class="font-bold">Delete</p>
                        <p class="text-sm text-gray-700 mt-1">
                            Are you sure you want to delete this conversation?
                        </p>
                    </div>
                </div>
                <div class="text-center md:text-right mt-4 md:flex md:justify-end">
                    <button id="confirm-delete-btn" (click)="confirm()"
                        class="block w-full cursor-pointer md:inline-block md:w-auto px-4 py-3 md:py-2 bg-red-200 text-red-700 rounded-lg font-semibold text-sm md:ml-2 md:order-2">
                        Delete
                    </button>
                    <button id="confirm-cancel-btn"  (click)="cancel()"
                        class="block w-full cursor-pointer md:inline-block md:w-auto px-4 py-3 md:py-2 bg-gray-200 rounded-lg font-semibold text-sm mt-4 md:mt-0 md:order-1">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
}
